import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import EditShopForm from '../../../components/Form/Tenant/EditShopForm';
import EditShopMedia from 'components/Form/Tenant/EditShopMedia';
import { useDetailQuery } from 'http-client/hooks/useCrud';
import { useParams } from 'react-router-dom';
import { ShopFormValues } from 'components/Types/Tenant/shop.type';
import { API_ENDPOINTS } from 'http-client/httpConstants';

const ShopDetailPage: React.FC = () => {
  const { shopId } = useParams<{ shopId: string }>();
  const { data: shopData } = useDetailQuery<ShopFormValues>(API_ENDPOINTS.TENANT.SHOPS.WITH_ID, {
    id: shopId!,
  });

  return (
    <div className="page-content">
      <Container fluid>
        <Row className="mb-4">
          <Col lg={12} md={12} className="mb-4">
            <EditShopMedia
              id={shopId || ''}
              name={shopData?.name || ''}
              isActive={shopData?.isActive || false}
              logoUrl={shopData?.logoUrl || 'https://placehold.co/100x100?text=Logo'}
              coverImageUrl={
                shopData?.coverImageUrl || 'https://placehold.co/800x200?text=Cover+Image'
              }
            />
          </Col>
        </Row>
        <Row className="mb-4">
          <Col lg={12} md={12} className="mb-4">
            <EditShopForm shopId={shopId!} />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ShopDetailPage;
